import React from 'react'
import "./new-style.css";
import Hero from './Hero';
import Campuses from './Campuses';
import Tabs from './Tabs';
import Steps from './Steps';
import Banner from './Banner';
import TrustedBy from './TrustedBy';
import RecognizedBy from './RecognizedBy';
import Team from './Team';
import Footer from '../../Components/Footer';
import { useCallback, useMemo,useEffect } from 'react';
import EmailModal from "../../Components/modals/Login"
import OTPModal from "../../Components/modals/OTP";
import useModalManager from "../../utils/ModalManager";
import { useDispatch,useSelector } from "react-redux";
// import { authenticate,validate } from "../../features/authSlice";
import { authenticate,validate } from "../../Redux/Actions/auth";
import { Notify } from "notiflix";
import { useNavigate } from "react-router-dom";
import Opportunities from "./Opportunities";

import Camera from "../../Assets/images/camera.svg"
import Gallery from "../../Assets/images/image.svg"
import Done from "../../Assets/images/modal-done.svg"
// import { getUser, updateUser } from "../../features/studentSlice";
const MODAL_TYPES = {
  EMAIL: 'email',
  OTP: 'otp',
};

const HomePage = () => {
  const {
    modalRefs,
    userEmail,
    setUserEmail,
    isLoading,
    setIsLoading,
    openModal,
    closeAllModals
  } = useModalManager();
const dispatch = useDispatch()
const navigate = useNavigate()
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const showotp = useSelector((state) => state.auth.showotp);
  const {userInitiated} = useSelector(state => state.student || {})
  useEffect(() => {
      if (isAuthenticated) {
        closeAllModals();
        navigate('/job-board');
      }
    }, [isAuthenticated]);
 useEffect(() => {
  
  if (showotp) {
    openModal(MODAL_TYPES.OTP);
  } else {
    closeAllModals();
  }
}, [showotp, openModal, closeAllModals]);

useEffect(() => {
  
  if (!userEmail) {
    dispatch({ type: 'RESET_OTP_MODAL' });
    closeAllModals();
  }
}, [userEmail, dispatch]);

  const handleClose = () => {
    dispatch({ type: 'RESET_OTP_MODAL' })
    closeAllModals();
  }
  const handleSendOTP = useCallback(async (mobile) => {
    setIsLoading(true);
    try {
      setUserEmail(mobile);
      const resultAction = await dispatch(authenticate({ mobile })).unwrap();
      openModal(MODAL_TYPES.OTP);
      // if (resultAction.status) {
      //       Notify.success(resultAction.message);
      //     } else {
      //       Notify.warning(resultAction.message);
      //     }
        } catch (err) {
          // Notify.failure('Failed to send OTP. Please try again.');
        }finally {
      setIsLoading(false);
    }
  }, [openModal, setUserEmail, setIsLoading]);

  const handleVerifyOTP = useCallback(async (mobile,otp) => {
    setIsLoading(true);
    try {
      const resultAction = await dispatch(validate({ mobile, secret: otp })).unwrap();
      closeAllModals();
      navigate('/job-board');
      // if (resultAction.data.status) {
      //       Notify.success(resultAction.data.message);
      //     } else {
      //       Notify.warning(resultAction.data.message);
      //     }
        } catch (err) {
          // Notify.failure('Failed to send OTP. Please try again.');
        }finally {
      setIsLoading(false);
    }
  }, [openModal,closeAllModals, setIsLoading]);

  const handleChangeEmail = useCallback(() => {
    openModal(MODAL_TYPES.EMAIL);
  }, [openModal]);

  const handleJobSeekersClick = useCallback((e) => {
    e.preventDefault();
    openModal(MODAL_TYPES.EMAIL);
  }, [openModal]);

  return (
    <>
      <Hero handleModal={handleJobSeekersClick}/>
      <Campuses/>
      <Tabs/>
      <Steps/>
      {/* <Opportunities /> */}
      <TrustedBy/>
      <Banner/>
      <RecognizedBy/>
      <Team/>
      <Footer/>

      <EmailModal
        modalRef={modalRefs[MODAL_TYPES.EMAIL]}
        onSendOTP={handleSendOTP}
        onClose={closeAllModals}
        isLoading={isLoading}
      />

      <OTPModal
        modalRef={modalRefs[MODAL_TYPES.OTP]}
        userEmail={userEmail}
        onVerifyOTP={handleVerifyOTP}
        onChangeEmail={handleChangeEmail}
        onClose={handleClose}
        isLoading={isLoading}
      />
      {/* Modals */}
      {/* <div className="modal fade common-modal" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form  className='portfolio-modals'>
                <h2 className="popup-title mb-0">Your Profile is Updated!</h2>
                <p className='modal-para my-4'><span className="default-color">Next Step :</span> Add videos to showcase your skills and increase your chances to get hire</p>
                <button type="submit"  className='default-btn blue-bg mb-3'>Update Screening Criteria</button>
                <button type="submit"  className='default-btn border-btn bg-transparent'>Skip</button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modals End */}

       {/* Modals */}
      {/* <div className="modal fade common-modal" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form  className='portfolio-modals'>
                <p className='modal-para pt-3 mb-4 pb-lg-2 text-start'>
                  I grant my consent to MasterNaukri to store & transmit my personal information (photos, videos, profile details etc.) as needed to deliver me a better & more personalized experience. I have read the <a href="" className="default-link">Terms & Conditions</a> and <a href=""  className="default-link">Privacy Policy.</a> 
                </p>
                <button type="submit"  className='default-btn blue-bg mb-3'>Ok</button>
                <button type="submit"  className='default-btn border-btn bg-transparent'>Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modals End */}

      {/* Modals */}
      {/* <div className="modal fade common-modal" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form  className='portfolio-modals'>
                <h2 className="popup-title mb-3 pb-lg-2">Choose an Option</h2>
                <div className="gallery-option-main my-5">
                  <div className="gallery-option">
                      <img src={Camera} alt="aa" />
                      Camera
                  </div>
                  <div className="gallery-option active">
                      <img src={Gallery} alt="aa" />
                      Camera
                  </div>
                </div>
                <button type="submit"  className='default-btn blue-bg mb-3'>Next</button>
                <button type="submit"  className='default-btn border-btn bg-transparent'>Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modals End */}


      {/* Modals */}
       {/* <div className="modal fade common-modal" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form  className='portfolio-modals'>
                <h2 className="popup-title mb-0">Confirm Submission</h2>
                <p className='modal-para my-4'>You are submitting for <a href='' className='default-link'>Aditya</a> in <a href='' className='default-link'>Sales</a> under the skill: <a href='' className='default-link'>Sales & Marketing</a></p>
                <button type="submit"  className='default-btn blue-bg mb-3'>Continue</button>
                <button type="submit"  className='default-btn border-btn bg-transparent'>Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modals End */}
      

      
      {/* Modals */}
       {/* <div className="modal fade common-modal portfolio-modals-main" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form className='portfolio-modals'>
                <h2 className="popup-title mb-0">Terms</h2>
                <p className='modal-para form-check-label my-4 text-start'>Please read and accept the terms of use</p>
                <div className='custom-radio-main mb-2 mb-md-5'>
                    <label className="checkbox-container form-checkbox align-items-start mb-3">
                        <input 
                            type="checkbox" 
                            className="form-check-input"
                        />
                        <span className="checkboxmark form-check-label flex-1">I allow MasterNaukri to share my submission with public for benefit of others</span>
                    </label>
                    
                    <label className="checkbox-container form-checkbox align-items-start mb-3">
                        <input 
                            type="checkbox" 
                            className="form-check-input"
                        />
                        <span className="checkboxmark form-check-label flex-1">I agree to abide by all the rules & regulations as defined & understand that violation of any rules or guideline may result in disqualification from the event</span>
                    </label>
                    
                    <label className="checkbox-container form-checkbox align-items-start mb-3">
                        <input 
                            type="checkbox" 
                            className="form-check-input"
                        />
                        <span className="checkboxmark form-check-label flex-1">I give consent to MasterNaukri to save my submission on their servers in India/outside as deemed appropriate by them</span>
                    </label>
                </div>
                <button type="submit"  className='default-btn w-100 blue-bg mb-3'>Accept & Submit</button>
                <button type="submit"  className='default-btn w-100 border-btn bg-transparent'>Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modals End */}

       {/* Modals */}
       {/* <div className="modal fade common-modal" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form  className='portfolio-modals text-center'>
                <h2 className="popup-title mb-0">Great Job!</h2>
                <p className='modal-para my-4'>Submitted Successfully </p>
                <img src={Done} alt="aa" className='mb-5' />
                <button type="submit"  className='default-btn blue-bg'>Ok</button>
              </form>
            </div>
          </div>
        </div>
      </div> */}
      {/* Modals End */}

      {/* Modals */}
       <div className="modal fade common-modal" tabIndex="" id="exampleModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button  type="button"   className="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
              <form  className='portfolio-modals'>
                <h2 className="popup-title mb-0">Confirm Delete</h2>
                <p className='modal-para my-4'>Are you sure you want to delete the added file?</p>
                <button type="submit"  className='default-btn blue-bg mb-3'>Delete</button>
                <button type="submit"  className='default-btn border-btn bg-transparent'>Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Modals End */}
      
    </>
  );
};

export default HomePage;
